<div
  ngbDropdown
  class="dropdown"
  ngbDropdown
  #customDropDown="ngbDropdown"
  (openChange)="dropDownChange($event)"
>
  <button
    [disabled]="isDisabled"
    class="btn btn-primary pe-3"
    ngbDropdownAnchor
    (click)="customDropDown.toggle()"
  >
    <span class="float-start px-2">{{ currentSelectedItem?.description }}</span>
    <span class="float-end">
      <i
        class="fas ps-1"
        aria-hidden="true"
        [ngClass]="{
          'fa-chevron-up': customDropDown.isOpen(),
          'fa-chevron-down': !customDropDown.isOpen()
        }"
      ></i>
    </span>
  </button>
  <ul class="w-100" ngbDropdownMenu>
    <li
      *ngIf="isSearchable"
      class="dropdown-item"
      (click)="$event.stopPropagation(); customDropDown.open()"
    >
      <div class="input-group input-group-sm">
        <div class="input-group-prepend">
          <i class="fas fa-search text-white py-3 py-md-2 pe-2"></i>
        </div>
        <input
          type="text"
          class="form-control bg-white"
          placeholder="Search"
          [(ngModel)]="searchFilterText"
          [ngModelOptions]="{ standalone: true }"
          autofocus
          (keyup)="searchFilter($event)"
          style="color: black"
        />
        <div class="input-group-append" *ngIf="searchFilterText.length > 0">
          <button
            class="btn btn-primary"
            type="button"
            (click)="clearSearch($event)"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </li>
    <li
      class="dropdown-item py-md-2 py-3 text-white"
      *ngFor="let item of displayList"
      (click)="optionSeleted(customDropDown, item)"
    >
      {{ item[description] }}
    </li>
  </ul>
</div>
